<div class="subscribers card">
    <!-- Subscriber filter -->
    <div class="input-wrapper input-wrapper_high input-wrapper_with-label input-wrapper_with-icon input-wrapper_type_select dropdown__select-wrapper">
        <span class="input-label">הצגת מנויים לפי</span>
        <select class="input" [(ngModel)]="classificationOption" (change)="filterDataSubscriber()">
            <option *ngFor="let classification of customClassificationSubscriber">
                {{ classification }}
            </option>
        </select>
    </div>

    <!-- Desktop table -->
    <div *ngIf="state == 'loaded' && !subscriber?.lststrip[0]?.lastDeleted" class="subscribers__section section-main custom-scrollbar">
        <p-table class="main__table" [value]="tmpStrip" dataKey="avodaInd" (onRowExpand)="onRowExpand($event)" [rows]="40" [paginator]="true">
            <ng-template pTemplate="body" let-rowData let-expanded="expanded">
                <div class="table__subscription-header" [ngClass]="{ 'subscription-header_disabled': !rowData.isVisibleUseSubsBtn }">
                    <div class="subscription-header__section section-right" [pRowToggler]="rowData">
                        <span class="section-right__chevron">
                            <i class="fa-regular fa-chevron-left" [ngClass]="{ 'row-expanded': expanded }"></i>
                        </span>
                        <i *ngIf="rowData.isVisibleUseSubsBtn" class="section-right__icon fa-regular fa-check"></i>
                        <i *ngIf="!rowData.isVisibleUseSubsBtn" class="section-right__icon fa-regular fa-ban"></i>
                        <div class="section-right__info">
                            <span class="info__name">{{ rowData.subscriberTypeCalc }} </span>
                            <span class="info__description">(נוצלו {{ rowData.lststripdetails.length }}/{{ rowData.amount }})</span>
                        </div>
                    </div>
                    <div class="subscription-header__section section-left">
                        <div class="section-left__info" *ngIf="rowData.isVisibleUseSubsBtn">
                            <div class="info__open-date info__date">
                                <span class="date__header">תאריך פתיחה</span>
                                <div class="date__main">
                                    <i class="fa-regular fa-calendar-lines"></i>
                                    <span>{{ rowData.openDateStr }}</span>
                                </div>
                            </div>
                            <div *ngIf="rowData.closeDateStr" class="info__close-date info__date">
                                <span class="date__header">בתוקף עד</span>
                                <div class="date__main">
                                    <i class="fa-regular fa-calendar-lines"></i>
                                    <span>{{ rowData.closeDateStr }}</span>
                                </div>
                            </div>
                        </div>
                        <button
                            *ngIf="rowData.isVisibleUseSubsBtn"
                            class="section-left__sub-button button"
                            (click)="addNewVisit(rowData)"
                            [disabled]="isDisabled(58)"
                        >
                            ניצול ידני
                        </button>
                        <div class="section-left__more">
                            <button class="more__button button button_icon-only" (click)="toggleSubMenu($event, menu, rowData.avodaInd, false)">
                                <i class="fa-solid fa-ellipsis-vertical"></i>
                            </button>
                            <p-menu #menu class="more__menu action-list" [model]="items_1" [popup]="true"></p-menu>
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="rowexpansion" let-rowData>
                <div class="table__body">
                    <div class="body__info">
                        <div class="info__element">
                            <span class="element__name">מחיר ששולם: </span>
                            <span class="element__value">{{ multivalues[0][rowData.avodaInd].sumtmp }} ₪</span>
                        </div>
                        <div class="info__element">
                            <span class="element__name">מטפל שמחר: </span>
                            <span class="element__value">{{ multivalues[0][rowData.avodaInd].saparNamePurchasetmp }}</span>
                        </div>
                        <div class="info__element">
                            <span class="element__name">מספר כרטיס: </span>
                            <span class="element__value">{{ multivalues[0][rowData.avodaInd].cardIdtmp }}</span>
                        </div>
                    </div>
                    <p-table
                        *ngIf="multi[rowData.avodaInd].length"
                        class="body__table"
                        [columns]="rowData.isShrOn ? cols : lockedCols"
                        [value]="multi[rowData.avodaInd]"
                        dataKey="ind"
                    >
                        <ng-template pTemplate="header" let-columns>
                            <tr class="table__header-row">
                                <th class="small-cell"></th>
                                <th *ngFor="let col of columns" [ngClass]="col.headerClass">
                                    {{ col.header }}
                                </th>
                                <th class="small-cell"></th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-rowData let-columns="columns">
                            <tr class="table__row" [pSelectableRow]="rowData">
                                <td class="small-cell check-cell">
                                    <i class="fa-regular fa-check"></i>
                                </td>
                                <td *ngFor="let col of columns" [ngClass]="col.headerClass">
                                    {{ rowData[col.field] }}
                                </td>
                                <td class="row__more-cell small-cell">
                                    <button
                                        class="more-cell__button button button_icon-only"
                                        (click)="toggleSubMenuDetails($event, menu, rowData.ind, rowData.avodaInd, false)"
                                    >
                                        <i class="fa-solid fa-ellipsis-vertical"></i>
                                    </button>
                                    <p-menu #menu class="more-cell__menu action-list" [model]="items_2" [popup]="true"></p-menu>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                    <div *ngIf="!multi[rowData.avodaInd].length" class="body__table_empty table-empty">
                        <span class="table-empty__header">אין עדיין ניצולים במנוי זה</span>
                        <span class="table-empty__text">כדי לנצל את המנוי ידנית לחצו על הכפתור ״ניצול ידני״</span>
                        <span class="table-empty__image"></span>
                    </div>
                </div>
            </ng-template>
        </p-table>
    </div>
    <!-- Mobile table -->
    <div *ngIf="state == 'loaded' && !subscriber?.lststrip[0]?.lastDeleted" class="subscribers__section_mobile section-main">
        <p-table class="main__table" [value]="tmpStrip" dataKey="avodaInd" (onRowExpand)="onRowExpand($event)" [rows]="40" [paginator]="true">
            <ng-template pTemplate="body" let-rowData let-expanded="expanded">
                <div class="table__subscription-header" [ngClass]="{ 'subscription-header_disabled': !rowData.isVisibleUseSubsBtn }">
                    <div class="subscription-header__wrapper">
                        <div class="subscription-header__section section-right" [pRowToggler]="rowData">
                            <span class="section-right__chevron">
                                <i class="fa-regular fa-chevron-left" [ngClass]="{ 'row-expanded': expanded }"></i>
                            </span>
                            <i *ngIf="rowData.isVisibleUseSubsBtn" class="section-right__icon fa-regular fa-check"></i>
                            <i *ngIf="!rowData.isVisibleUseSubsBtn" class="section-right__icon fa-regular fa-ban"></i>
                            <div class="section-right__info">
                                <span class="info__name">{{ rowData.subscriberTypeCalc }} </span>
                                <span class="info__description">(נוצלו {{ rowData.lststripdetails.length }}/{{ rowData.amount }})</span>
                            </div>
                        </div>
                        <div class="subscription-header__section section-left">
                            <div class="section-left__more">
                                <button class="more__button button button_icon-only" (click)="toggleSubMenu($event, null, rowData.avodaInd, true)">
                                    <i class="fa-solid fa-ellipsis-vertical"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="subscription-header__info">
                        <div class="info__open-date info__date">
                            <span class="date__header">תאריך פתיחה</span>
                            <div class="date__main">
                                <i class="fa-regular fa-calendar-lines"></i>
                                <span>{{ rowData.openDateStr }}</span>
                            </div>
                        </div>
                        <div *ngIf="rowData.closeDateStr" class="info__close-date info__date">
                            <span class="date__header">בתוקף עד</span>
                            <div class="date__main">
                                <i class="fa-regular fa-calendar-lines"></i>
                                <span>{{ rowData.closeDateStr }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="rowexpansion" let-rowData>
                <div class="table__body">
                    <div class="body__info">
                        <div class="info__element">
                            <span class="element__name">מחיר ששולם: </span>
                            <span class="element__value">{{ multivalues[0][rowData.avodaInd].sumtmp }}</span>
                        </div>
                        <div class="info__element">
                            <span class="element__name">מטפל שמחר: </span>
                            <span class="element__value">{{ multivalues[0][rowData.avodaInd].saparNamePurchasetmp }}</span>
                        </div>
                    </div>
                    <button
                        *ngIf="rowData.isVisibleUseSubsBtn"
                        class="body__sub-button button"
                        (click)="addNewVisit(rowData)"
                        [disabled]="isDisabled(58)"
                    >
                        ניצול ידני
                    </button>
                    <p-table *ngIf="multi[rowData.avodaInd].length" class="body__table" [value]="multi[rowData.avodaInd]" dataKey="ind">
                        <ng-template pTemplate="header">
                            <tr class="table__header-row">
                                <th class="small-cell"></th>
                                <th class="small-cell info-cell">תאריך</th>
                                <th class="large-cell">הערות</th>
                                <th class="small-cell"></th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-rowData let-i="rowIndex">
                            <tr class="table__row" [pSelectableRow]="rowData">
                                <td class="small-cell check-cell">
                                    <i class="fa-regular fa-check"></i>
                                </td>
                                <td class="small-cell info-cell">
                                    <span class="info-cell__name">ניצול {{ rowData.ind }}</span>
                                    <span class="info-cell__date">{{ rowData.dateVisitStr }}</span>
                                </td>
                                <td class="large-cell">{{ rowData.comments }}</td>
                                <td class="row__more-cell small-cell">
                                    <button
                                        class="more-cell__button button button_icon-only"
                                        (click)="toggleSubMenuDetails($event, null, rowData.ind, rowData.avodaInd, true)"
                                    >
                                        <i class="fa-solid fa-ellipsis-vertical"></i>
                                    </button>
                                    <p-menu #menu class="more-cell__menu action-list" [model]="items_2" [popup]="true"></p-menu>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                    <div *ngIf="!multi[rowData.avodaInd].length" class="body__table_empty table-empty">
                        <span class="table-empty__header">אין עדיין ניצולים במנוי זה</span>
                        <span class="table-empty__text">כדי לנצל את המנוי ידנית לחצו על הכפתור ״ניצול ידני״</span>
                        <span class="table-empty__image"></span>
                    </div>
                </div>
            </ng-template>
        </p-table>
    </div>

    <!-- Empty subscriber list -->
    <div *ngIf="state == 'nosubscribers' || subscriber?.lststrip[0]?.lastDeleted" class="subscribers__section_empty section-empty">
        <span class="section-empty__header">אין עדיין מנויים ללקוח/ה</span>
        <span class="section-empty__text">ליצירת מנוי חדש לחץ על הכפתור פלוס הכחול שבתחתית המסך</span>
        <span class="section-empty__image"></span>
    </div>

    <button class="subscribers__add-button button button_icon-only button_theme_main" (click)="addSubscriber()" [disabled]="isDisabled(59)">
        <i class="fa-regular fa-plus"></i>
    </button>

    <!-- Modals -->

    <!-- Subscriber adding and editing modal -->
    <p-dialog
        [ngClass]="{ 'custom-dialog': isAddingOrEditingSubscriber }"
        styleClass="modal modal_type_subscriber"
        [(visible)]="isAddingOrEditingSubscriber"
        header="{{ dialogTitle }}"
        [modal]="true"
        [resizable]="false"
        [draggable]="false"
    >
        <p-tabView class="modal__tabview" [(activeIndex)]="activeIndex">
            <!-- Subscriber typeSubs 1 -->
            <p-tabPanel
                class="tabview__tabpanel-header"
                header="לפי תקופה"
                [disabled]="editedStrip && editedStrip.typeSubs == 1 && isAddingOrEditingSubscriber == 2"
            >
                <div class="tabview__tabpanel-body">
                    <div
                        *ngIf="isAddingOrEditingSubscriber != 2"
                        class="tabpanel-body__section section-dropdown dropdown-filter input-wrapper input-wrapper_with-label"
                    >
                        <span class="input-label">בחירת טיפול</span>
                        <p-dropdown
                            class="input dropdown__input"
                            [ngClass]="{ dropdown__input_error: subscriberOptionError }"
                            [options]="subscribersList"
                            [(ngModel)]="subscriberOption"
                            (onChange)="subscriberOptionError = false"
                            filter="true"
                            filterPlaceholder="חפש"
                            resetFilterOnHide="true"
                            emptyFilterMessage="לא נמצאו טיפולים מתאימים"
                            (onShow)="saveDisabled = true"
                            (onHide)="saveDisabled = false"
                        >
                            <ng-template let-option pTemplate="selectedItem">
                                <span>{{ option.label }}</span>
                            </ng-template>
                            <ng-template let-option pTemplate="item">
                                <div>
                                    <div>{{ option.label }}</div>
                                </div>
                            </ng-template>
                        </p-dropdown>
                        <span *ngIf="subscriberOptionError" class="input__error-text">חובה לבחור סוג טיפול</span>
                    </div>
                    <div
                        *ngIf="isAddingOrEditingSubscriber == 2"
                        class="tabpanel-body__section input-wrapper input-wrapper_with-label input-wrapper_disabled dropdown-filter"
                    >
                        <span class="input-label">בחירת טיפול</span>
                        <input class="input" [(ngModel)]="subscriberOption" disabled />
                    </div>
                    <div class="tabpanel-body__section tabpanel-body__section_column_mobile">
                        <div class="section__datepicker">
                            <div
                                class="datepicker__input input-wrapper input-wrapper_with-label input-wrapper_with-icon input-wrapper_type_datepicker"
                                [ngClass]="{
                                    'input-wrapper_disabled': isAddingOrEditingSubscriber == 2,
                                    'input-wrapper_error': closeDateError && newSubscriberCloseDateModel.invalid,
                                    'input-wrapper_with-details': closeDateError && newSubscriberCloseDateModel.invalid
                                }"
                            >
                                <span class="input-label">הגבל מנוי עד</span>
                                <input
                                    class="input"
                                    bsDatepicker
                                    [(appDateMask)]="newSubscriberCloseDate"
                                    [(ngModel)]="newSubscriberCloseDate"
                                    [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', isAnimated: true, adaptivePosition: true }"
                                    [minDate]="minDate"
                                    #newSubscriberCloseDateModel="ngModel"
                                    type="text"
                                    placeholder="בחר"
                                    autocomplete="off"
                                    [disabled]="isAddingOrEditingSubscriber == 2"
                                    required
                                />
                                <span *ngIf="closeDateError && newSubscriberCloseDateModel.invalid" class="input-details">בחר את התאריך הנכון</span>
                            </div>
                        </div>
                        <div class="section__input input-wrapper input-wrapper_with-label">
                            <span class="input-label">מחיר ששולם (₪)</span>
                            <input
                                class="input"
                                [(ngModel)]="newSubscriberSum"
                                maxlength="4"
                                autocomplete="off"
                                (input)="onInputChange('newSubscriberSum', $event.target)"
                            />
                        </div>
                    </div>
                    <div class="tabpanel-body__section">
                        <div
                            class="section__dropdown section-dropdown worker-dropdown input-wrapper input-wrapper_type_select input-wrapper_with-label input-wrapper_with-icon"
                            [ngClass]="{ 'input-wrapper_disabled': isAddingOrEditingSubscriber == 2 }"
                        >
                            <span class="input-label">מטפל שמכר</span>
                            <div class="dropdown__select-wrapper">
                                <select
                                    class="input dropdown__input dropdown__input-worker"
                                    [(ngModel)]="workerOption"
                                    [disabled]="isAddingOrEditingSubscriber == 2"
                                >
                                    <option *ngFor="let worker of workers">
                                        {{ worker.saparName }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="section__input input-wrapper input-wrapper_with-label">
                            <span class="input-label">מספר כרטיס</span>
                            <input
                                class="input"
                                [(ngModel)]="newSubscriberCardId"
                                maxlength="6"
                                autocomplete="off"
                                (input)="onInputChange('newSubscriberCardId', $event.target)"
                            />
                        </div>
                    </div>
                    <div class="tabpanel-body__buttons-wrapper buttons-wrapper_second modal__footer">
                        <button
                            *ngIf="isAddingOrEditingSubscriber == 1"
                            class="buttons-wrapper__button button button_theme_main"
                            (click)="saveNewSubscriber(2)"
                            [disabled]="saveDisabled"
                        >
                            שמירה
                        </button>
                        <button
                            *ngIf="isAddingOrEditingSubscriber == 2"
                            class="buttons-wrapper__button button button_theme_main"
                            (click)="saveEditedSubscriber()"
                        >
                            שמירה
                        </button>
                        <button class="buttons-wrapper__button button button_theme_gray-line" (click)="cancelButton()">בטל</button>
                    </div>
                </div>
            </p-tabPanel>
            <!-- Subscriber typeSubs 2 -->
            <p-tabPanel
                class="tabview__tabpanel-header"
                header="לפי כמות"
                [disabled]="editedStrip && editedStrip.typeSubs == 2 && isAddingOrEditingSubscriber == 2"
            >
                <div class="tabview__tabpanel-body">
                    <div
                        *ngIf="isAddingOrEditingSubscriber != 2"
                        class="tabpanel-body__section section-dropdown dropdown-filter input-wrapper input-wrapper_with-label"
                    >
                        <span class="input-label">בחירת טיפול</span>
                        <p-dropdown
                            class="input dropdown__input"
                            [ngClass]="{ dropdown__input_error: subscriberOptionError }"
                            [options]="subscribersList"
                            [(ngModel)]="subscriberOption"
                            (onChange)="subscriberOptionError = false"
                            filter="true"
                            filterPlaceholder="חפש"
                            resetFilterOnHide="true"
                            emptyFilterMessage="לא נמצאו טיפולים מתאימים"
                            (onShow)="saveDisabled = true"
                            (onHide)="saveDisabled = false"
                        >
                            <ng-template let-option pTemplate="selectedItem">
                                <span>{{ option.label }}</span>
                            </ng-template>
                            <ng-template let-option pTemplate="item">
                                <div>
                                    <div>{{ option.label }}</div>
                                </div>
                            </ng-template>
                        </p-dropdown>
                        <span *ngIf="subscriberOptionError" class="input__error-text">חובה לבחור סוג טיפול</span>
                    </div>
                    <div
                        *ngIf="isAddingOrEditingSubscriber == 2"
                        class="tabpanel-body__section input-wrapper input-wrapper_with-label input-wrapper_disabled dropdown-filter"
                    >
                        <span class="input-label">בחירת טיפול</span>
                        <input class="input" [(ngModel)]="subscriberOption" disabled />
                    </div>
                    <div class="tabpanel-body__section tabpanel-body__section_column_mobile">
                        <div class="section__range">
                            <div
                                class="input-wrapper input-wrapper_with-label input-wrapper_type_range"
                                [ngClass]="{ 'input-wrapper_disabled': isAddingOrEditingSubscriber == 2 }"
                            >
                                <span class="input-label">כמות טיפולים</span>
                                <div class="range">
                                    <button
                                        class="range__button range__button_minus"
                                        (click)="decrementAmount()"
                                        [disabled]="isAddingOrEditingSubscriber == 2"
                                    >
                                        <i class="fa-regular fa-minus"></i>
                                    </button>
                                    <input
                                        class="input"
                                        [(ngModel)]="newSubscriberAmount"
                                        [disabled]="isAddingOrEditingSubscriber == 2"
                                        (focus)="onRangeFocus($event.target)"
                                        (input)="onRangeChange('newSubscriberAmount', $event.target, 1, 100)"
                                    />
                                    <button
                                        class="range__button range__button_plus"
                                        (click)="incrementAmount()"
                                        [disabled]="isAddingOrEditingSubscriber == 2"
                                    >
                                        <i class="fa-regular fa-plus"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="section__input input-wrapper input-wrapper_with-label">
                            <span class="input-label">מחיר ששולם (₪)</span>
                            <input
                                class="input"
                                [(ngModel)]="newSubscriberSum"
                                maxlength="4"
                                autocomplete="off"
                                (input)="onInputChange('newSubscriberSum', $event.target)"
                            />
                        </div>
                    </div>
                    <div class="tabpanel-body__section">
                        <div
                            class="section__dropdown section-dropdown worker-dropdown input-wrapper input-wrapper_type_select input-wrapper_with-label input-wrapper_with-icon"
                            [ngClass]="{ 'input-wrapper_disabled': isAddingOrEditingSubscriber == 2 }"
                        >
                            <span class="input-label">מטפל שמכר</span>
                            <div class="dropdown__select-wrapper">
                                <select
                                    class="input dropdown__input dropdown__input-worker"
                                    [(ngModel)]="workerOption"
                                    [disabled]="isAddingOrEditingSubscriber == 2"
                                >
                                    <option *ngFor="let worker of workers">
                                        {{ worker.saparName }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="section__input input-wrapper input-wrapper_with-label">
                            <span class="input-label">מספר כרטיס</span>
                            <input
                                class="input"
                                [(ngModel)]="newSubscriberCardId"
                                maxlength="6"
                                autocomplete="off"
                                (input)="onInputChange('newSubscriberCardId', $event.target)"
                            />
                        </div>
                    </div>
                    <div class="tabpanel-body__section tabpanel-body__section_column_mobile">
                        <!-- <label class="checkbox-label" [ngClass]="{ 'checkbox-label_disabled': isAddingOrEditingSubscriber == 2 }"> -->
                        <label class="checkbox-label checkbox-label_disabled">
                            <span *ngIf="!isDateLimited">הגבל תוקף מנוי לתאריך מסוים</span>
                            <span *ngIf="isDateLimited">המנוי הוגבל עד לתאריך</span>
                            <!-- <input class="checkbox" type="checkbox" [(ngModel)]="isDateLimited" [disabled]="isAddingOrEditingSubscriber == 2" /> -->
                            <input class="checkbox" type="checkbox" [(ngModel)]="isDateLimited" [disabled]="true" />
                            <span class="custom-checkbox"></span>
                        </label>
                        <div
                            *ngIf="isDateLimited"
                            class="section__datelimit datepicker__input input-wrapper input-wrapper_with-icon input-wrapper_type_datepicker"
                            [ngClass]="{
                                'input-wrapper_disabled': isAddingOrEditingSubscriber == 2,
                                'input-wrapper_error': closeDateError && newSubscriberCloseDateModel.invalid,
                                'input-wrapper_with-details': closeDateError && newSubscriberCloseDateModel.invalid
                            }"
                        >
                            <input
                                class="input"
                                bsDatepicker
                                [(appDateMask)]="newSubscriberCloseDate"
                                [(ngModel)]="newSubscriberCloseDate"
                                [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', isAnimated: true, adaptivePosition: true }"
                                [minDate]="minDate"
                                #newSubscriberCloseDateModel="ngModel"
                                type="text"
                                placeholder="בחר"
                                autocomplete="off"
                                [disabled]="isAddingOrEditingSubscriber == 2"
                                required
                            />
                            <span *ngIf="closeDateError && newSubscriberCloseDateModel.invalid" class="input-details">חובה לבחור תאריך</span>
                        </div>
                    </div>
                    <div class="tabpanel-body__buttons-wrapper buttons-wrapper_first modal__footer">
                        <button
                            *ngIf="isAddingOrEditingSubscriber == 1"
                            class="buttons-wrapper__button button button_theme_main"
                            (click)="saveNewSubscriber(1)"
                            [disabled]="saveDisabled"
                        >
                            שמירה
                        </button>
                        <button
                            *ngIf="isAddingOrEditingSubscriber == 2"
                            class="buttons-wrapper__button button button_theme_main"
                            (click)="saveEditedSubscriber()"
                        >
                            שמירה
                        </button>
                        <button class="buttons-wrapper__button button button_theme_gray-line" (click)="cancelButton()">בטל</button>
                    </div>
                </div>
            </p-tabPanel>
        </p-tabView>
    </p-dialog>

    <!-- Subscriber deleting -->
    <p-dialog
        [ngClass]="{ 'custom-dialog': isDeletingSubscriber }"
        styleClass="modal modal_type_confirm"
        [(visible)]="isDeletingSubscriber"
        header="מחיקה"
        [modal]="true"
        [resizable]="false"
        [draggable]="false"
    >
        <span class="modal__text">האם את/ה בטוח/ה במחיקת מנוי?</span>
        <div class="modal__footer">
            <button class="button button_size_small button_theme_gray-line" (click)="cancelButton()">ביטול</button>
            <button class="button button_size_small button_theme_main" (click)="deleteSubscriber()">מחיקה</button>
        </div>
    </p-dialog>

    <!-- Visit editing -->
    <p-dialog
        [ngClass]="{ 'custom-dialog': isEditingVisit, 'reduced-modal_type_visit': !newVisitIsShrOn }"
        styleClass="modal modal_type_visit"
        [(visible)]="isEditingVisit"
        header="עריכת ניצול מס׳ {{ newVisitInd }}"
        [modal]="true"
        [resizable]="false"
        [draggable]="false"
    >
        <!-- <div class="modal__section modal__section_type_inputs"> -->
            <div
                class="datepicker__input input-wrapper input-wrapper_type_datepicker input-wrapper_with-label input-wrapper_with-icon"
                [ngClass]="{
                    'input-wrapper_error': visitDateError && newVisitDateModel.invalid,
                    'input-wrapper_with-details': visitDateError && newVisitDateModel.invalid
                }"
            >
                <span class="input-label">תאריך ניצול</span>
                <input
                    class="input"
                    bsDatepicker
                    [(appDateMask)]="newVisitDate"
                    [(ngModel)]="newVisitDate"
                    [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', isAnimated: true, adaptivePosition: true }"
                    [minDate]="minVisitDate"
                    #newVisitDateModel="ngModel"
                    type="text"
                    placeholder="בחר"
                    autocomplete="off"
                    required
                />
                <span *ngIf="visitDateError && newVisitDateModel.invalid" class="input-details">בחר את התאריך הנכון</span>
            </div>

            <div class="section__input input-wrapper input-wrapper_with-label input-wrapper_disabled">
                <span class="input-label">שם המטפל/ת</span>
                <input class="input" autocomplete="off" [(ngModel)]="newVisitWorker" disabled />
            </div>
        <!-- </div> -->

        <!-- <div *ngIf="newVisitIsShrOn" class="modal__section modal__section_type_inputs"> -->
            <div *ngIf="newVisitIsShrOn" class="section__input input-wrapper input-wrapper_with-label">
                <span class="input-label">ג׳אול</span>
                <input class="input" autocomplete="off" [(ngModel)]="newVisitJoul" />
            </div>

            <div *ngIf="newVisitIsShrOn" class="section__input input-wrapper input-wrapper_with-label">
                <span class="input-label">עוצמה</span>
                <input class="input" autocomplete="off" [(ngModel)]="newVisitMS" />
            </div>
        <!-- </div> -->

        <!-- <div *ngIf="newVisitIsShrOn" class="modal__section modal__section_type_inputs"> -->
            <div *ngIf="newVisitIsShrOn" class="section__input input-wrapper input-wrapper_with-label">
                <span class="input-label">סוג שיער</span>
                <input class="input" autocomplete="off" [(ngModel)]="newVisitHairType" />
            </div>

            <div *ngIf="newVisitIsShrOn" class="section__input input-wrapper input-wrapper_with-label">
                <span class="input-label">גוון שיער</span>
                <input class="input" autocomplete="off" [(ngModel)]="newVisitSkinType" />
            </div>
        <!-- </div> -->

        <!-- <div *ngIf="newVisitIsShrOn" class="modal__section modal__section_type_inputs"> -->
            <div *ngIf="newVisitIsShrOn" class="section__input input-wrapper input-wrapper_with-label">
                <span class="input-label">סוג ידית</span>
                <input class="input" autocomplete="off" [(ngModel)]="newVisitTypeHandle" />
            </div>
        <!-- </div> -->

        <!-- <div class="modal__section"> -->
            <div class="section__input input-wrapper input-wrapper_with-label input-wrapper_type_textarea">
                <span class="input-label">הערה</span>
                <textarea class="input" [(ngModel)]="newVisitComments" placeholder="הוסף הערות..." autocomplete="off"></textarea>
            </div>
        <!-- </div> -->

        <div class="modal__footer">
            <button class="button button_size_small button_theme_gray-line" (click)="cancelButton()">בטל</button>
            <button class="button button_size_small button_theme_main" (click)="saveEditedVisit()">שמירה</button>
        </div>
    </p-dialog>

    <!-- Visit deleting -->
    <p-dialog
        [ngClass]="{ 'custom-dialog': isDeletingVisit }"
        styleClass="modal modal_type_confirm"
        [(visible)]="isDeletingVisit"
        header="מחיקת ניצול"
        [modal]="true"
        [resizable]="false"
        [draggable]="false"
    >
        <span class="modal__text">האם את/ה בטוח/ה במחיקת ניצול?</span>
        <div class="modal__footer">
            <button class="button button_size_small button_theme_gray-line" (click)="cancelButton()">בטל</button>
            <button class="button button_size_small button_theme_main" (click)="deleteVisit()">מחיקה</button>
        </div>
    </p-dialog>

    <!-- Mobile strip menu -->
    <p-dialog
        [ngClass]="{ 'custom-dialog': isSubscriberMenuOpened }"
        styleClass="modal modal_type_menu modal_subscribers-menu"
        [(visible)]="isSubscriberMenuOpened"
        header="פעולות נוספות"
        [modal]="true"
        [resizable]="false"
        [draggable]="false"
        transitionOptions="0ms"
    >
        <button
            *ngFor="let item of items_1"
            class="menu-button {{ item.icon }} button button_with-icon"
            (click)="item.command()"
            [disabled]="item.disabled"
        >
            {{ item.label }}
        </button>
    </p-dialog>

    <!-- Mobile substrip menu -->
    <p-dialog
        [ngClass]="{ 'custom-dialog': isVisitMenuOpened }"
        styleClass="modal modal_type_menu modal_visits-menu"
        [(visible)]="isVisitMenuOpened"
        header="פעולות נוספות"
        [modal]="true"
        [resizable]="false"
        [draggable]="false"
        transitionOptions="0ms"
    >
        <button
            *ngFor="let item of items_2"
            class="menu-button {{ item.icon }} button button_with-icon"
            (click)="item.command()"
            [disabled]="item.disabled"
        >
            {{ item.label }}
        </button>
    </p-dialog>
</div>

<p-messages class="messages"></p-messages>

<div
    appHostListenerBeforeUnload
    (componentHasChangedOutput)="this.componentHasChanged = $event"
    [saveData]="saveData"
    [receivedData]="subscriber"
></div>
